export const homeCarouselImages = [
  require("./web-banner-img.png"),
  require("./home-inspectors-toolbox-desktop-dashboard.png"),
  require("./home-inspectors-toolbox-preview-mobile-set-a.png"),
  require("./home-inspectors-toolbox-preview-mobile-set-b.png"),
];
